// extracted by mini-css-extract-plugin
module.exports = {"company-performance":"CompanyPerformance_company-performance__36gI9","loading":"CompanyPerformance_loading__3rVQE"};